import { AuthenticationEvents } from "@teaming/common-enums";
import { listenTo } from "@teaming/io-helpers/channelHelpers";
import debugFactory from "debug";

const debug = debugFactory( "teaming:teaming-web:stores:host-layout" );

export default function layoutChannelWireUp( { auth, ioChannel, store, } ) {
	let _auth0User;

	const normalizeProfileNames = userProfile => {
		if ( !userProfile ) {
			return;
		}

		const updates = {};

		// preserve the user's preferred name as first name, since
		// we are now allowing the user to directly edit first/last name,
		// but are deprecating preferred name
		if ( userProfile.preferredName && ( userProfile.firstName !== userProfile.preferredName ) ) {
			updates.firstName = userProfile.preferredName;
			updates.preferredName = "";
		}

		// update the user's first/last name from auth0 if those values
		// have not yet been set; also update any avatar changes
		/* eslint-disable camelcase */
		if ( _auth0User ) {
			const { given_name, family_name, picture: auth0picture, } = _auth0User;
			const { firstName, lastName, picture, } = userProfile;
			if ( given_name && !( updates.firstName || firstName ) ) {
				updates.firstName = given_name;
			}
			if ( family_name && !lastName ) {
				updates.lastName = family_name;
			}
			if ( auth0picture && ( picture !== auth0picture ) ) {
				updates.picture = auth0picture;
			}
		}
		/* eslint-enable camelcase */

		if ( Object.keys( updates ).length ) {
			userProfile = {
				...userProfile,
				...updates,
			};
			ioChannel.publish( "user.saveUserProfile.invoke", userProfile );
		}

		return userProfile;
	};

	auth.on(
		AuthenticationEvents.LOGIN,
		( { userProfile, auth0User, } ) => {
			_auth0User = auth0User;
			debug( "handling Authentication.LOGIN", userProfile );
			store.commit( "host-userProfile/receiveUserProfile", userProfile );
			store.commit( "host-userProfile/receiveAuth0Profile", auth0User );
			store.commit( "host-userProfile/receiveLoginStatus", { isLoggedIn: true, } );
			// reload the user profile so we get all the user data, not just what
			// comes from the auth service
			ioChannel.publish( "user.getUserProfile.invoke", {} );
		}
	);

	auth.on(
		AuthenticationEvents.SIGNUP,
		( { userProfile, auth0User, } ) => {
			_auth0User = auth0User;
			debug( "handling Authentication.SIGNUP", userProfile );
			store.commit( "host-userProfile/receiveUserProfile", userProfile );
			store.commit( "host-userProfile/receiveAuth0Profile", auth0User );
			store.commit( "host-userProfile/receiveLoginStatus", { isLoggedIn: true, } );
			// reload the user profile so we get all the user data, not just what
			// comes from the auth service
			ioChannel.publish( "user.getUserProfile.invoke", {} );
		}
	);

	auth.on(
		AuthenticationEvents.LOGOUT,
		() => {
			store.commit( "host-userProfile/receiveLoginStatus", { isLoggedIn: false, } );
		}
	);

	listenTo( ioChannel, "user.getUserProfile", {
		success: ( { response: userProfile, } ) => {
			userProfile = normalizeProfileNames( userProfile );
			store.commit( "host-userProfile/receiveUserProfile", userProfile );
		},
	} );

	listenTo( ioChannel, "user.saveUserProfile", {
		success: ( { response: userProfile, } ) => {
			store.commit( "host-userProfile/receiveUserProfile", userProfile );
		},
	} );

	listenTo( ioChannel, "user.updateSettings", {
		success: _ => {
			ioChannel.publish( "user.getUserProfile.invoke", { refetch: true, } );
		},
	} );
}
